// extracted by mini-css-extract-plugin
export var newsletterConfirmContainer = "newsletter-module--newsletter-confirm-container--350a8";